export const CompanyType = Object.freeze({
  soleTrader: 1,
  limitedLiabilityPartnership: 2,
  limitedCompany: 3,
  startup: 4,
});

export const CompanyTypeLabel = Object.freeze({
  [CompanyType.soleTrader]: 'Sole Trader',
  [CompanyType.limitedLiabilityPartnership]: 'Limited Liability Partnership',
  [CompanyType.limitedCompany]: 'Limited Company',
  [CompanyType.startup]: 'Startup',
});

export const CompanyTypeLabelQuestionnaireId = Object.freeze({
  [CompanyType.soleTrader]: 1,
  [CompanyType.limitedLiabilityPartnership]: 2,
  [CompanyType.limitedCompany]: 3,
  [CompanyType.startup]: 4,
});

export const CompanyBusinessType = Object.freeze({
  soleTrader: 'SOLE_TRADER',
  limitedCompany: 'LIMITED_COMPANY',
  llp: 'LLP',
  lpp: 'LPP',
  limitedLiabilityPartnership: 'LIMITED_LIABILITY_PARTNERSHIP',
});

export const CompanyTypeFromLabel = Object.freeze({
  [CompanyBusinessType.soleTrader]: 1,
  [CompanyBusinessType.limitedLiabilityPartnership]: 2,
  [CompanyBusinessType.limitedCompany]: 3,
  [CompanyBusinessType.startup]: 4,
});

export function toOptions() {
  return Object.values(CompanyType).map((value) => ({ label: CompanyTypeLabel[value], value }));
}

export function toOptionsUiSchema() {
  return Object.entries(CompanyTypeLabel).map(([value, label]) => ({ label, value }));
}
